import { render, staticRenderFns } from "./SupplierTop5PerPerson.vue?vue&type=template&id=ceed29a4&"
import script from "./SupplierTop5PerPerson.vue?vue&type=script&lang=js&"
export * from "./SupplierTop5PerPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports